import {B2cProductParameter, B2cProductPayload} from "@/generated/graphql/b2c.ts";
import { stockType as productStockType } from "@/constants/product-stock.ts";
import { ProductStateType } from "@/util/constants.ts";
import {TFunction} from "i18next";

export const getFilteredCrosses = (product: B2cProductPayload) => {
  const allowed = ["oe", "oem", "aftermarket"];
  const all = product.crosses ?? [];
  const filtered = [product!, ...all].filter((product) => {
    const productType = product.productType || product.brand?.defaultProductType;
    if (allowed.includes(productType) && product.state === 1 && !!product.productType) {
      return product.prices.some((price) => parseFloat(price.price.amount) > 0);
    }
  });
  return filtered;
};

export interface DefineOutOfStockProps {
  hasPrice: boolean;
  isHidePriceIfProductIsOutOfStock: boolean;
  deliveryStandardTimesIsNotDefined: boolean;
  stockType: string;
  productState: number;
}

export const defineOutOfStock = (props: DefineOutOfStockProps) => {
  const { hasPrice, isHidePriceIfProductIsOutOfStock, deliveryStandardTimesIsNotDefined, stockType, productState } = props;

  return (
    hasPrice &&
    isHidePriceIfProductIsOutOfStock &&
    productState !== ProductStateType.OnRequest &&
    (stockType === productStockType.undefinedStock || deliveryStandardTimesIsNotDefined)
  );
};

export const getSpecifications = (product: B2cProductPayload, t: TFunction<"translation", undefined>) => {
  const specifications = product!.productParameters
      .filter((parameter: B2cProductParameter) => !!parameter.name && parameter.value !== null && parameter.value?.trim() !== '')
      .map((spec: B2cProductParameter) => ({
        name: spec.name,
        value: spec.value,
        type: spec.type,
      }));

  const staticSpecifications: B2cProductParameter[] = [];

  if (product.brand.name) {
    staticSpecifications.push({
      id: "static-param-brand",
      name: t("v0vi8228d2e6gbge.brand", "Brand"),
      type: "",
      value: product.brand.name,
    });
  }

  if (product.weight.value) {
    staticSpecifications.push({
      id: "static-param-weight",
      name: t("gj7ao5qyeb898nyx.weight", "Weight"),
      type: t("kll27o98o69dqzw0.kg", product.weight.unit),
      value: product.weight.value,
    });
  }

  if (product.dimensions.width || product.dimensions.height || product.dimensions.depth) {
    const dimensionsValue = `${product.dimensions.width || "--"} x ${product.dimensions.height || "--"} x ${product.dimensions.depth || "--"}`;

    staticSpecifications.push({
      id: "static-param-dimensions",
      name: t("92jj5c7lfh3fiqt2.dimensions", "Dimensions"),
      type: t("dw613mgqhvlda8ea.mm", product?.dimensions.unit),
      value: dimensionsValue,
    });
  }

  return [...specifications, ...staticSpecifications];
};
